import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id D1FA251F-4332-4BA9-8742-F194C0B0BF28
 * name chess-rook
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chess-rook.svg
 * tags
 * - Gaming / RPG 
 */
export const ChessRookIcon = createSvgIcon(<><path d="M5,20H19V22H5V20M17,2V5H15V2H13V5H11V2H9V5H7V2H5V8H7V18H17V8H19V2H17Z" /></>, 'ChessRookIcon');
export default ChessRookIcon